import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { Tender, Project } from 'toolbandi-ui-lib';
import { Search, SortDirection, CrudService, MessageService } from 'elbuild-ui-lib-core';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TenderEditComponent } from '../tender-edit/tender-edit.component';
import { ProjectEditComponent } from '../../project/project-edit/project-edit.component';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-tender-list',
	templateUrl: './tender-list.component.html',
	styleUrls: ['./tender-list.component.scss']
})
export class TenderListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: Tender[];

	advancedSearch: Search = new Search('tender', 'name', 'tender');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;


	constructor(
		private cdr: ChangeDetectorRef,
		private tenderService: CrudService<Tender>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private router: Router,
		private dialogService: DialogService,
		private modalService: NgbModal
	) {
		this.advancedSearch.setSortDirection(SortDirection.DESCENDING);
		this.advancedSearch.setSortField('projectdeadline');
	}

	ngOnInit(): void {
	}

	ngAfterViewInit(): void {
		this.listfilters.readParams().subscribe((data) => {
			this.search(data);
		});
	}
	ngOnDestroy(): void {
	}

	load(): void {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();


		const datarequest = this.tenderService.searchEntities(Tender, 'tender', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.tenderService.countEntities(Tender, 'tender', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any): void {

		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any): void {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any): void {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.router.navigate([`/tender/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			}
		}
	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: Tender, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-tender-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.tenderService.deleteEntity(Tender, 'tender', row).subscribe(() => {
					this.translateService.get(['labels.tender-deleted', 'labels.tenders']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.tender-deleted'], messages['labels.tenders']);
						this.load();
					});
				});
			}
		});
	}


	edit(tenderid?: number) {
		const modal = this.modalService.open(TenderEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		if (tenderid) {
			modal.componentInstance.load(tenderid);
		}
		modal.result.then((newItem: Tender) => {
			this.load();
		}).catch(() => { });
	}

	createProject(tender: Tender) {
		const modal = this.modalService.open(ProjectEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		if (tender) {
			modal.componentInstance.selected.tender = tender;
		}
		modal.result.then((newItem: Project) => {
			this.router.navigate([`/company/project/view/${newItem.id}`], { queryParamsHandling: 'merge' });
		}).catch(() => { });
	}

}
